var Buffer = require('buffer').Buffer;

module.exports = function(buf) {
  var out = new Buffer(buf.length);
  buf.copy(out);
  return out;
};



//////////////////
// WEBPACK FOOTER
// ./~/vinyl/lib/cloneBuffer.js
// module id = 4049
// module chunks = 0